import React from 'react';
import PropTypes from 'prop-types';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import InformationStack from '../stacks/InformationStack';

const DateWarning = ({ warning, sx, ...props }) => (
  <InformationStack
    text={warning.message}
    backgroundColor="info.A100"
    textColor="info.A700"
    variant="small_2"
    IconComponent={<InfoOutlinedIcon sx={{ color: 'info.A700' }} />}
    sx={sx}
    {...props}
  />
);

DateWarning.propTypes = {
  warning: PropTypes.shape({
    message: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
  }).isRequired,
  sx: PropTypes.shape({}),
};

DateWarning.defaultProps = {
  sx: {},
};

export default DateWarning;
